import Detail from './index.vue'
export default Detail